import { useEffect } from "react";
/*
Пагинация добавляет в адрес страницы #2 и т.д
Поэтому оно отслеживается и убирается
*/
const useCleanPaginationURL = () => {
  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash) {
        const cleanUrl = window.location.pathname + window.location.search;
        window.history.pushState(null, "", cleanUrl);
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);
};

export default useCleanPaginationURL;
